import { render, staticRenderFns } from "./showMore.vue?vue&type=template&id=06dfb9b8&"
import script from "./showMore.vue?vue&type=script&lang=js&"
export * from "./showMore.vue?vue&type=script&lang=js&"
import style0 from "./showMore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports